import { DivisionChartComponentBody } from './index';
import { useCallback, useEffect } from 'react';
import { useDashboardDivisions } from '@hooks/useDashboardDivisions';
import {
  DivisionChartItemType,
  DivisionsCentersFormattedItemType,
  DivisionsFormattedItemType,
  centerLoading,
} from '@type/dashboard';
import { useDashboardDivisionCenters } from '@hooks/useDashboardDivisionCenters';
import { useInitialSettings } from '@hooks/useInitialSettings,';
import Spinner from '@components/Spinner';
import { useOutletContext } from 'react-router-dom';
import { OutletContextType } from '@type/outletContext';

export const DivisionChartComponent = ({
  searchParams,
}: {
  searchParams: URLSearchParams;
}) => {
  const { divisionsList, isLoading } = useDashboardDivisions();

  const { divisionChartState, setDivisionChartState } =
    useOutletContext<OutletContextType>();

  const { initialSettings, isLoading: isInitialSettingsLoading } =
    useInitialSettings();

  const {
    handleQuery,
    dashboardCenters,
    isLoading: isAllCentersLoading,
  } = useDashboardDivisionCenters();

  const handler = (
    id: number,
    name: 'toggleDivision' | 'switchChartType',
    value: boolean,
  ) => {
    setDivisionChartState((prev: DivisionChartItemType[]) => {
      prev[id][`${name}`] = value;
      return [...prev];
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const cacheHandler = useCallback(handler, []);

  useEffect(() => {
    if (initialSettings?.length > 0) {
      setDivisionChartState(initialSettings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSettings]);

  return isInitialSettingsLoading ? (
    <div className="w-100 h-50 d-flex justify-content-center align-items-center py-20">
      <div className="py-20">
        <Spinner />
      </div>
    </div>
  ) : (
    divisionChartState.map((item: DivisionChartItemType, index) => {
      const findData = divisionsList?.find(
        (nestedItem: DivisionsFormattedItemType) =>
          nestedItem.id === item.divisionId,
      );

      const dashboardCenter = dashboardCenters?.find(
        (centerItem: DivisionsCentersFormattedItemType) =>
          centerItem.divisionId === item.divisionId,
      );

      const isCenterLoading = isAllCentersLoading?.find(
        (loader: centerLoading) => loader.divisionId === item.divisionId,
      );

      return (
        <DivisionChartComponentBody
          key={index}
          index={index}
          handler={cacheHandler}
          divisionData={findData}
          handleQuery={handleQuery}
          divisionId={item.divisionId}
          isDivisionLoading={isLoading}
          initialAsonId={item.initialAsonId}
          dashboardCenter={dashboardCenter}
          toggleDivision={item.toggleDivision}
          switchChartType={item.switchChartType}
          title={item.name}
          isCenterLoading={isCenterLoading?.loading as boolean}
          searchParams={searchParams}
        />
      );
    })
  );
};
